<template>
  <div class="workflow-rule" v-bind="$attrs" data-test="workflow-rule">
    <slot name="header">
      <WdsStack direction-column gap-md>
        <WdsStack justify-space-between>
          <WdsStack align-center gap-md class="tw-w-full">
            <WdsStack class="icon-highlight" align-center justify-center>
              <slot name="icon"></slot>
            </WdsStack>
            <slot name="title"></slot>
          </WdsStack>
          <WdsButtonIcon v-if="canDelete" sm transparent-background @click="$emit('delete')">
            <WdsIcon :size="14" color="#B2B2BF" name="trash-can" />
          </WdsButtonIcon>
        </WdsStack>
      </WdsStack>
    </slot>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { WdsStack, WdsButtonIcon, WdsIcon } from '@worksome/wds-components'

defineEmits(['delete'])

defineProps({
  canDelete: {
    type: Boolean,
    default: false,
  },
})
</script>

<style lang="scss" scoped>
.workflow-rule {
  padding: 12px;
  position: relative;
  overflow: visible;
  width: 400px;
  background: white;
  z-index: 15;
  border: 2px solid var(--border-color);
  border-radius: 10px;
  margin-bottom: -1px;

  &::before {
    content: '';
    width: 2px;
    height: calc(2rem - 2px);
    z-index: 0;
    background: var(--border-color);
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -1px;
  }

  .icon-highlight {
    background-color: #f2f2f2;
    width: 40px;
    height: 40px;
    align-items: center;
    border-radius: 6px;
  }

  :deep(.wds-select) {
    .wds-select-text {
      max-width: 336px;
    }

    .wds-select-list-container {
      min-width: 366px;
    }
  }

  :deep(.new-field-option) {
    width: 366px;
    margin: 0 0.5rem 0.25rem;
    .option-label {
      padding: 0.5rem;
      &:hover {
        background-color: rgb(248 248 248 / var(--tw-bg-opacity));
      }
    }
  }

  :deep(#option-new_group-0),
  :deep(#option-new_custom_field-0) {
    border-bottom: 1px solid var(--border-color);
    margin: 0 0 0.25rem;
    padding: 0;
    &:hover {
      background-color: inherit;
    }
  }
}
</style>
